export default "__VITE_PUBLIC_ASSET__0e685589__"